/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */

import React from 'react'
import styles from './styles.module.scss'
import global from '../global_cal_style.module.scss'
import { arrayOfTimesGeneral, generateTimeSpanArray, isCurrentTimeInRange, splitMMDD, thisWeekGenerator } from '../timeLines'
import { ReactComponent as AddIcon } from '../../../../assets/icons/plus-ico.svg'
import { ReactComponent as ClockIcon } from '../../../../assets/icons/clock-icon.svg'
import AptMiniCard from '../AptMiniCard'

// Function to capitalize first letter of each word
const capitalizeWords = (text) => {
  if (!text) return text
  return text.split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ')
}

// Function to deduplicate appointments by patient when they have same date and time
const deduplicateAppointmentsByPatient = (appointments) => {
  const patientTimeMap = new Map()
  
  appointments.forEach(appointment => {
    const key = `${appointment.patient_id}-${appointment.date}-${appointment.from}-${appointment.to}`
    
    if (!patientTimeMap.has(key)) {
      patientTimeMap.set(key, appointment)
    } else {
      // If duplicate exists, keep the first appointment and ignore duplicates
      // console.log(`Duplicate appointment found for patient ${appointment.patient_id} at ${appointment.date} ${appointment.from}-${appointment.to}`)
    }
  })
  
  return Array.from(patientTimeMap.values())
}

// Function to generate vertical lines for 30-minute intervals
const generateTimeLines = (timeSpan) => {
  const lines = []
  const totalMinutes = timeSpan * 30 // Each span represents 30 minutes
  
  // Create lines every 30 minutes
  for (let i = 1; i < totalMinutes / 30; i++) {
    const position = (i * 30 / totalMinutes) * 100
    lines.push(
      <div
        key={i}
        style={{
          position: 'absolute',
          left: `calc(${position}% - 1px)`,
          top: 0,
          bottom: 0,
          width: '2px',
          backgroundColor: '#e0e0e0',
          zIndex: 1,
          pointerEvents: 'none'
        }}
      />
    )
  }
  
  return lines
}

const RegularTable = ({ t, create, appointmentsArray, handleEditApt, selectedDate, users = [] }) => {
  // Filter out fast service appointments
  const filteredAppointments = appointmentsArray.filter(app => !app.is_fast_service);
  // Deduplicate appointments before processing
  const deduplicatedAppointments = deduplicateAppointmentsByPatient(filteredAppointments)
  
  const thisWeek = thisWeekGenerator(selectedDate)
  const newDate = new Date()
  return (
    <table className={global.schedule_table}>
      <thead>
        <tr>
          <th className={global.header_cell}>
            <ClockIcon className={global.clock_icon} />
          </th>
          {arrayOfTimesGeneral.map((time, indexTime) => {
            const { displayValue } = time
            const isGoing = isCurrentTimeInRange(newDate, displayValue, arrayOfTimesGeneral[indexTime + 1]?.displayValue)
            return (
              <th key={displayValue} className={`${global.header_cell} ${isGoing ? global.going_now : ''}`}>
                {displayValue}
              </th>
            )
          })}
        </tr>
      </thead>
      <tbody>
        {thisWeek.map((date) => {
          const { day, isToday, fullDate } = date
          const todaysAppointments = deduplicatedAppointments.filter((appointment) => appointment.date === date.fullDate)
          const arrayOfspanTimes = generateTimeSpanArray(arrayOfTimesGeneral, todaysAppointments)
          return (
            <tr key={day}>
              <td className={`${global.day_cell} ${isToday ? global.today : ''}`}>
                <div className={global.day_info_wrap}>
                  <span className={global.day_text}>{day}</span>
                  <span className={global.date_text}>{splitMMDD(fullDate)}</span>
                </div>
              </td>
              {arrayOfspanTimes.map((time, index) => {
                const { fullspan, appointments } = time
                return (
                  <td
                    key={index}
                    colSpan={fullspan}
                    //
                    className={`${global.td_cell} ${isToday ? global.today : ''}`}
                    style={{ position: 'relative' }}
                  >
                    {/* Add vertical time lines at cell level */}
                    {generateTimeLines(fullspan)}
                    
                    {appointments?.length > 0 ? (
                      <div
                        className={styles.appointments_container}
                        style={{
                          height:
                            // Nëse ka vetëm një takim dhe zgjat fiks 1 orë, vendos height fikse
                            appointments.length === 1 && (() => {
                              const appointmentData = deduplicatedAppointments.find((appointment) => appointment.id === appointments[0])
                              return appointmentData && appointmentData.to - appointmentData.from === 1
                            })()
                              ? '60px'
                            // Nëse ka fiks 2 takime, vendos height më të vogël
                            : appointments.length === 2
                              ? '90px'
                              : `${Math.max(fullspan * 60, appointments.length * 45 + 60)}px`
                        }}
                        onClick={() => create({ time, date })}
                      >
                        {appointments.map((appointmentId, index) => {
                          const appointmentData = deduplicatedAppointments.find((appointment) => appointment.id === appointmentId)
                          const { name, patient_name, from, to, color, is_paid, doctor_id } = appointmentData || {}
                          const doctor = users.find(user => user.id === doctor_id)
                          return (
                            <div key={appointmentId} className={styles.appointment_container}>
                              <div
                                className={styles.appointment}
                                style={{
                                  left: `calc(${(((from - time.from) * 2) / fullspan) * 100}% + 4px)`,
                                  width: `calc(${(((to - from) * 2) / fullspan) * 100}% - 8px)`,
                                  backgroundColor: doctor?.color || color || 'gray',
                                  border: is_paid ? '2px solid black' : '2px solid transparent'
                                }}
                                onClick={(e) => {
                                  e.stopPropagation()
                                  handleEditApt(appointmentData)
                                }}
                              >
                                <div className={styles.apt_details}>
                                  <span className={styles.time}>{capitalizeWords(patient_name || name)}</span>
                                  {/* <span className={styles.description}>{description}</span> */}
                                </div>
                                <div className={`${global.apt_mini_card} ${styles.apt_mini_card}`}>
                                  <AptMiniCard card={appointmentData} t={t} />
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    ) : (
                      <div className={global.empty_apt_container}>
                        <button className={global.add_button} onClick={() => create({ time, date })}>
                          <AddIcon />
                        </button>
                      </div>
                    )}
                  </td>
                )
              })}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default RegularTable
